module.exports = __webpack_public_path__ + "img/sec2_3_.5ec442b9.png";